import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeFeConfirmModule } from 'se-fe-confirm';
import { SeFeToastModule } from 'se-fe-toast';

@Component({
  selector: 'se-public-api-root',
  template: `
    <router-outlet></router-outlet>
    <se-fe-toast></se-fe-toast>
    <se-fe-confirm></se-fe-confirm>
  `,
  imports: [
    RouterOutlet,
    SeFeToastModule,
    SeFeConfirmModule,
  ]
})
export class AppComponent {
}
